import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-[#C6FF3C] py-3 px-4 text-center" data-id="element-12">
      <p className="text-black font-bold text-sm md:text-base uppercase tracking-wide" data-id="element-13">
        🔥 OFERTA EXCLUSIVA - SOLO POR HOY 🔥
      </p>
    </div>;
}